<template>
  <div class="changePassword">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="修改密码" name="first">
        <personalHead title :hide="true" />
        <div class="form">
          <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="125px"
            class="demo-ruleForm"
          >
            <el-row :gutter="20">
              <el-col :xs="24" :sm="24" :md="24">
                <el-form-item label="原密码" prop="oldPassword">
                  <el-input
                    type="password"
                    v-model="ruleForm.oldPassword"
                    placeholder="请输入原密码"
                    style="width:100%"
                    show-password
                    auto-complete="new-password"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24">
                <el-form-item label="新密码" prop="newPassword">
                  <el-input
                    type="password"
                    v-model="ruleForm.newPassword"
                    placeholder="请输入新密码"
                    style="width:100%"
                    show-password
                    auto-complete="new-password"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24">
                <el-form-item label="确认密码" prop="checkPass">
                  <el-input
                    type="password"
                    v-model="ruleForm.checkPass"
                    placeholder="请确认新密码"
                    style="width:100%"
                    show-password
                    auto-complete="new-password"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24">
                <el-form-item class="submit">
                  <el-button
                    type="danger"
                    @click="save('ruleForm')"
                    style="width:100px;height:40px"
                  >修 改</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="修改手机号" name="second">
        <personalHead title :hide="true" />
        <div class="form">
          <el-form
            :model="bindForm"
            status-icon
            :rules="bindRules"
            ref="bindForm"
            label-width="125px"
            class="demo-ruleForm"
          >
            <el-form-item label="新手机号码" prop="mobile">
              <el-input v-model="bindForm.mobile" placeholder="请输入您新手机号码" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input
                v-model="bindForm.code"
                placeholder="短信验证码"
                autocomplete="off"
                maxlength="4"
              >
                <el-button
                  slot="append"
                  @click="getCode('bindForm')"
                  class="verificationCode"
                  style="color: #67C23A"
                  :disabled="timeLoading"
                >{{!timeLoading?'获取验证码':checkTime+'S重新获取'}}</el-button>
              </el-input>
            </el-form-item>
            <el-col :xs="24" :sm="24" :md="24">
              <el-form-item class="submit">
                <el-button
                  type="danger"
                  style="width:100px;height:40px"
                  @click="bind('bindForm')"
                >换 绑</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="隐私" name="three" v-if="userRole==1">
        <div style="padding:20px;display: flex;align-items: center;">
          <label style="margin-right:20px">是否将个人基本信息及证书证章信息展示在运动员列表中</label>
          <el-switch v-model="isopen.isopen" @change="privacyChange"></el-switch>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import personalHead from "@/views/admin/components/personalHead.vue";
import { mapGetters } from "vuex";
import { isMobile } from "@/util/validate.js";
import {
    GetOpenQuery,
    SetOpenQuery
} from "@/api/admin/athletes.js";
import {
  ModifyPassword,
  GetMessageCode,
  MobileVerify
} from "@/api/admin/login.js";
export default {
  components: {
    personalHead
  },
  computed: {
    ...mapGetters(["userInfo","userRole"])
  },
  data() {
    var checkPassWord = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.ruleForm.newPassword) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkmobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入联系方式"));
      } else {
        if (isMobile(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的电话"));
        }
      }
    };
    var checkCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        if (String(value).length == 4) {
          callback();
        } else {
          return callback(new Error("请输入四位数验证码"));
        }
      }
    };
    return {
      ruleForm: {},
      rules: {
        oldPassword: [
          { required: true, message: "原密码不能为空", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "新密码不能为空", trigger: "blur" }
        ],
        checkPass: [
          { required: true, validator: checkPassWord, trigger: "blur" }
        ]
      },
      activeName: "first",
      bindForm: {},
      bindRules: {
        code: [{ required: true, validator: checkCode, trigger: "blur" }],
        mobile: [{ required: true, validator: checkmobile, trigger: "blur" }]
      },
      checkTime: "",
      timeLoading: false,
      timer: null,
      isopen:{
        isopen:false
      }
    };
  },
  created(){
    this.getList();
  },
  methods: {
    getList(){
        GetOpenQuery({}).then(res => {
            if(res.data.result.isSuccess){
                this.isopen.isopen=res.data.result.is_open;
            }
        })
    },
    save(ruleForm) {
      const form = {
        oldPassword: this.ruleForm.oldPassword,
        newPassword: this.ruleForm.newPassword
      };

      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          ModifyPassword(form).then(data => {
            const list = data.data;
            if (list.success) {
              if (list.result.isSuccess) {
                this.$store.dispatch("loginOut");
                this.$router.push({ path: "/" });
                this.$message({
                  message: "修改成功",
                  duration: 3000,
                  type: "success"
                });
              } else {
                
                this.$message({
                  message: list.result.errorMsg,
                  duration: 3000,
                  type: "error"
                });
              }
            }
          });
        } else {
          return false;
        }
      });
    },
    getCode(bindForm) {
      this.$refs[bindForm].validateField("mobile", errMsg => {
        if (!errMsg) {
          GetMessageCode({ mobile: this.bindForm.mobile }).then(data => {
            
            const list = data.data.result;
            if (list) {
              if (list.isSuccess) {
                this.$message({
                  message:
                    "验证码已成功发送至“ " +
                    this.bindForm.mobile +
                    " ”请您注意查收",
                  type: "success",
                  duration: "5000"
                });
                if (!this.timer) {
                  this.checkTime = 120;
                  this.timeLoading = true;
                  this.timer = setInterval(() => {
                    if (this.checkTime > 0 && this.checkTime <= 120) {
                      this.checkTime--;
                    } else {
                      clearInterval(this.timer);
                      this.timeLoading = false;
                      this.timer = null;
                    }
                  }, 1000);
                }
              } else {
                this.$message.error("验证码发送失败，请重新获取");
              }
            }
          });
        }
      });
    },
    bind(bindForm) {
      this.bindForm.usertype = this.userInfo.usertype;
      this.$refs[bindForm].validate(valid => {
        if (valid) {
          MobileVerify(this.bindForm).then(data => {
            if (data.data.result) {
              if (data.data.result.isSuccess) {
                this.$store.dispatch("loginOut");
                this.$router.push({ path: "/" });
                this.$message({
                  message: "绑定成功",
                  type: "success"
                });
              } else {
                this.$message({
                  message: data.data.result.errorMsg,
                  type: "warning"
                });
              }
            }
          });
        } else {
          return false;
        }
      });
    },
    privacyChange() {
      SetOpenQuery(Object.assign(this.isopen)).then(res => {
        if(res.data.result.isSuccess){
            this.$message({
                message: '设置成功',
                type: 'success'
            });
            this.getList();
        }
        else{
            this.$message.error('设置失败');
            this.isopen.isopen=false;
        }
      })
    },
    handleClick(tab) {
      if (tab.index == 2) {
        //window.console.log(tab);
      }
    }
  }
};
</script>
<style lang="less">
.changePassword {
  .form {
    width: 60%;
    .submit {
      .el-form-item__content {
        margin-left: 0px !important;
        text-align: center;
        margin: 30px 0px;
      }
    }
  }
  @media screen and (max-width: 500px) {
    .quaul {
      width: 100% !important;
    }
    .form {
      width: 100% !important;
      .el-form-item__label {
        width: 110px !important;
        float: none;
      }
      .el-form-item__content {
        margin-left: 30px !important;
        float: none;
      }
      .content {
        .el-form-item__content {
          margin-left: 0px !important;
        }
      }
      .center {
        text-align: center;
      }
    }
  }
}
</style>
